import {createNavigationContainerRef, NavigatorScreenParams} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
export const navigationRef = createNavigationContainerRef();

export function navigate(name: string, params?: any) {
  if (navigationRef.isReady()) {
    // @ts-ignore
    navigationRef.navigate(name, params);
  }
}

export enum Nav {
  HomeScreen = 'HomeScreen',
  SettingsScreen = 'SettingsScreen',
  CreatePaymentScreens = 'CreatePaymentScreens',
  CreatePaymentPhoneScreen = 'CreatePaymentPhoneScreen',
  CreatePaymentAmountScreen = 'CreatePaymentAmountScreen',
  CreatePaymentMessageScreen = 'CreatePaymentMessageScreen',
  PaymentScreen = 'PaymentScreen',
  PaymentsScreen = 'PaymentsScreen',
  PaymentQRScreen = 'PaymentQRScreen',
  RechargeScreen = 'RechargeScreen',
  RechargeViewScreen = 'RechargeViewScreen',
  PayoutScreen = 'PayoutScreen',
  ScanPaymentScreen = 'ScanPaymentScreen',
  ReceivePaymentScreen = 'ReceivePaymentScreen',
  IdSessionScreen = 'IdSessionScreen',
  EditAccountScreen = 'EditAccountScreen',
  NotFound = 'NotFound'
}

type CreatePaymentParams = {
  [Nav.CreatePaymentPhoneScreen]: undefined;
  [Nav.CreatePaymentAmountScreen]: {phoneNumber: string};
  [Nav.CreatePaymentMessageScreen]: {amount: number; phoneNumber: string; message?: string};
};

export type NavParams = CreatePaymentParams & {
  [Nav.HomeScreen]: undefined;
  [Nav.SettingsScreen]: undefined;
  [Nav.CreatePaymentScreens]: NavigatorScreenParams<CreatePaymentParams> | undefined;
  [Nav.PaymentsScreen]: undefined;
  [Nav.PaymentScreen]: {paymentId: string};
  [Nav.PaymentQRScreen]: {paymentId: string};
  [Nav.RechargeScreen]: undefined;
  [Nav.RechargeViewScreen]: {url: string};
  [Nav.PayoutScreen]: undefined;
  [Nav.ScanPaymentScreen]: undefined;
  [Nav.ReceivePaymentScreen]: undefined;
  [Nav.IdSessionScreen]: undefined;
  [Nav.EditAccountScreen]: {payout: boolean} | undefined;
  [Nav.NotFound]: undefined;
};

export const Stack = createStackNavigator<NavParams>();
